// extracted by mini-css-extract-plugin
export var arrow = "banner-module--arrow--da550";
export var banner = "banner-module--banner--55762";
export var content = "banner-module--content--8803c";
export var title = "banner-module--title--739e9";